// mode.js — Pilot-/Clean-Modus.
//
// "Lokale Daten löschen (Pilotmodus)" setzt dida_clean: Ab dann liefern
// alle Demo-Fallbacks (Beispiel-Patienten, -Termine, -Rezepte, Demo-Praxis
// "Dr. Sandra Hoffmann" …) leere Werte statt Demodaten — auch im
// Demo-Build ohne Supabase. "Demo-Daten laden" hebt den Modus wieder auf.
import { isSupabaseConfigured } from "./supabase";

export const isCleanMode = () => {
  try { return localStorage.getItem("dida_clean") === "1"; } catch { return false; }
};

// Läuft gerade eine Demo-Sitzung? ("Demo-Daten laden" gesetzt — auch im
// Live-Build eine rein lokale Sandbox, damit Demo-Daten weder von leeren
// Serverdaten überschrieben werden noch in die echte Datenbank sickern.)
export const demoSessionActive = () => {
  try { return !!localStorage.getItem("dida_demo_loaded"); } catch { return false; }
};

// Sollen Stores den Server ansprechen? Nur im Live-Build ohne Demo-Sitzung.
export const serverActive = () => isSupabaseConfigured && !demoSessionActive();

// Dürfen Demo-Beispieldaten als Fallback erscheinen?
export const demoFallbacks = () => !serverActive() && !isCleanMode();
